export const TIME_FORMAT: string = 'A hh시 mm분';
